import { render, staticRenderFns } from "./selfSigninSucceeded.vue?vue&type=template&id=49dc860a&scoped=true"
import script from "./selfSigninSucceeded.vue?vue&type=script&lang=js"
export * from "./selfSigninSucceeded.vue?vue&type=script&lang=js"
import style0 from "./selfSigninSucceeded.vue?vue&type=style&index=0&id=49dc860a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dc860a",
  null
  
)

export default component.exports